import { cn } from "@win-reality/react-ui";

type ModeCardProps = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
};

export const ModeCard = ({
  label,
  icon,
  onClick,
  isLoading = false,
  disabled = false,
}: ModeCardProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={cn(
        // Size
        "w-full",
        // Layout
        "flex items-center",
        // Spacing
        "gap-4 p-6",
        // Border
        "rounded border border-border-input",
        // Background
        "bg-white",
        // Text
        "text-left",
        // Effects
        "transition-shadow",
        // States
        disabled || isLoading
          ? "cursor-not-allowed opacity-60"
          : "cursor-pointer hover:bg-gray-50 hover:shadow-md",
      )}
    >
      <div
        className={cn(
          // Size
          "h-10 w-10 shrink-0",
          // Layout
          "flex items-center justify-center",
          // Border
          "rounded",
          // Background
          "bg-icon-bg-blue/10",
          // Text
          "text-blue",
        )}
      >
        {isLoading ? (
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-blue border-t-transparent" />
        ) : (
          icon
        )}
      </div>
      <span className="text-sm font-semibold text-text-light">{label}</span>
    </button>
  );
};
